import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { getPriceByDiscount } from 'utils';

const useStyles = makeStyles((theme) => createStyles({
    textField: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 200
      }
    }
  }));

export default function EditDetails({
  handleChangeName,
  handleChangeFormat,
  handleChangeTehnique,
  handleChangeDiscount,
  handleChangePrice,
  name,
  format,
  price,
  variant,
  discount,
  tehnique
}) {
  const classes = useStyles();
  const newPrice = discount && `Preț Nou -> ${getPriceByDiscount(price, discount)}`;

  return (
    <form className={classes.textField} noValidate autoComplete="off">
      <div>
        <TextField
          variant={variant}
          color="secondary"
          onChange={handleChangeName}
          label="Titlu Imaginii"
          defaultValue={name}
        />
      </div>
      <div>
        <TextField
          variant={variant}
          color="secondary"
          onChange={handleChangeTehnique}
          label="Tehnica"
          defaultValue={tehnique}
        />
      </div>
      <div>
        <TextField
          variant={variant}
          color="secondary"
          onChange={handleChangeFormat}
          label="Format"
          defaultValue={format}
        />
      </div>
      <div>
        <TextField
          variant={variant}
          color="secondary"
          onChange={handleChangePrice}
          label="Preț Standard"
          defaultValue={price}
          helperText={newPrice}
          error={discount}
        />
      </div>
      <div>
        <TextField
          variant={variant}
          color="secondary"
          onChange={handleChangeDiscount}
          label="Reducere (în %)"
          defaultValue={discount}
        />
      </div>
    </form>
  );
}
